/**
 * Bottom navigation.
 *
 * At the bottom because this is a one-handed app used on deck: the thumb
 * reaches the bottom third of a phone and nowhere near the top. Five
 * destinations is the ceiling before the targets drop under 48px on a small
 * iPhone, which is why "Settings" absorbs everything that is not daily work.
 */

import { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { api } from '../lib/api'
import type { Notification } from '../lib/types'

const ITEMS = [
  { to: '/', glyph: '⚓', label: 'Chart', end: true },
  { to: '/applications', glyph: '☰', label: 'Mine', end: false },
  { to: '/apply', glyph: '＋', label: 'Apply', end: false },
  { to: '/friends', glyph: '⚑', label: 'Friends', end: false },
  { to: '/settings', glyph: '⚙', label: 'Settings', end: false },
]

export function BottomNav() {
  const [unread, setUnread] = useState(0)

  useEffect(() => {
    // Cheap poll rather than a socket: this is a count, five minutes late is
    // fine, and a push has already woken the device for anything urgent.
    const load = () =>
      void api
        .get<Notification[]>('/api/push/notifications?limit=20')
        .then((rows) => setUnread(rows.filter((r) => !r.delivered_at).length))
        .catch(() => undefined)
    load()
    const timer = window.setInterval(load, 5 * 60 * 1000)
    return () => window.clearInterval(timer)
  }, [])

  return (
    <nav className="bottom-nav" aria-label="Main">
      {ITEMS.map((item) => (
        <NavLink key={item.to} to={item.to} end={item.end}>
          <span className="glyph" aria-hidden="true">
            {item.glyph}
          </span>
          <span>{item.label}</span>
          {item.to === '/applications' && unread > 0 && (
            <span className="nav-dot" aria-label={`${unread} new`}>
              {unread}
            </span>
          )}
        </NavLink>
      ))}
    </nav>
  )
}
